import { EpimsBaseEntityDto } from './epim-base.dto';
export class DocumentTypeCodeDto extends EpimsBaseEntityDto {

    DocumentTypeCodeName: string;
    DocumentTypeCodeMainName: string;  
    SubscriptionUserId: string;
    Version: number; 
    length: number;

}